import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MyButton from '../../util/myButton';
import CircularProgress from '@material-ui/core/CircularProgress';


//icon
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';


import { connect } from 'react-redux';
import { postSoundOff, clearErrors } from '../../redux/actions/dataActions';
import DialogTitle from '@material-ui/core/DialogTitle';


const styles = (theme) => ({
    ...theme.spread,
    submitButton: {
        position: 'relative',
        marginTop: 10,
        float: 'right'
    },
    progressSpinner: {
        position: 'absolute'
    },
    closeButton: {
        position: 'absolute',
        left: '90%',
        top: '10%'
    }
});

class PostSoundOff extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            body: "",
            errors: {}
        };
    }
    handleOpen = () => {
        this.setState(() => {
            return {
                open: true
            }
        })
    }
    handleClose = () => {
        this.props.clearErrors();
        this.setState(() => {
            return {
                open: false,
                errors: {}
            }
        })
    }
    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState(() => {
            return {
                [name]: value
            }
        })
    }
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.postSoundOff({ body: this.state.body })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState(() => {
                return {
                    errors: nextProps.UI.errors,
                }
            })
        }
        if (!nextProps.UI.errors && !nextProps.UI.loading) {
            this.setState(() => {
                return {
                    body: '',
                    open: false,
                    errors: {}

                }
            })
        }
    }
    render() {
        const { errors } = this.state;
        const { classes, UI: { loading } } = this.props;
        return (
            <React.Fragment>
                <MyButton onClick={this.handleOpen} tip='Sound Off!'>
                    <AddIcon color='primary' />
                </MyButton>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth='sm'>
                    <MyButton tip='Close' onClick={this.handleClose} btnClassName={classes.closeButton}>
                        <CloseIcon />
                    </MyButton>
                    <DialogTitle>
                        Post a new Sound Off
                    </DialogTitle>
                    <DialogContent>
                        <form onSubmit={this.handleSubmit}>
                            <TextField multiline name='body' type='text' label='My Post' rows='3' placeholder='post something witty....' error={errors.error ? true : false} helperText={errors.error} className={classes.TextField} onChange={this.handleChange} fullWidth />
                            <Button type='submit' variant='contained' color='primary' className={classes.submitButton} disabled={loading}>
                                Submit
                                {loading && (
                                    <CircularProgress size={30} className={classes.progressSpinner} />
                                )}
                            </Button>
                        </form>
                    </DialogContent>


                </Dialog>
            </React.Fragment>
        )
    }
}


PostSoundOff.propTypes = {
    postSoundOff: PropTypes.func.isRequired,
    UI: PropTypes.object.isRequired,
    clearErrors: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    UI: state.UI
})

export default connect(mapStateToProps, { postSoundOff, clearErrors })(withStyles(styles)(PostSoundOff));
